import { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send, CheckCircle, MessageCircle, Car, Star, ArrowRight, ArrowUpRight, Instagram } from 'lucide-react';
import { LogosCarousel } from '../components/LogosCarousel';
import { ChatWidget } from '../components/ChatWidget';

const WHATSAPP_URL = 'https://wa.me/5551985521710';
const INSTAGRAM_URL = 'https://www.instagram.com/avenida_veiculos_oficial_';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Simular envio do formulário
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      setIsSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Erro ao enviar mensagem:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    {
      icon: <Phone className="h-6 w-6" />,
      title: "Telefone",
      details: ["(51) 99521-2121", "(51) 99520-7441", "(51) 98554-3345"],
      description: "Ligue agora para falar com nossos especialistas"
    },
    {
      icon: <Mail className="h-6 w-6" />,
      title: "Email",
      details: ["Avenidaveiculos.rs@gmail.com", "Avenidaveiculos.rs@terra.com.br"],
      description: "Envie suas dúvidas por email"
    },
    {
      icon: <Instagram className="h-6 w-6" />,
      title: "Instagram",
      details: ["@avenida_veiculos_oficial_"],
      description: "Siga nosso perfil para ver novidades e ofertas",
      link: INSTAGRAM_URL
    },
    {
      icon: <MapPin className="h-6 w-6" />,
      title: "Endereço",
      details: ["Avenida João Pereira de Vargas, 132", "Centro - Sapucaia do Sul/RS", "CEP: 93220-190"],
      description: "Venha nos visitar em nossa loja"
    },
    {
      icon: <Clock className="h-6 w-6" />,
      title: "Horário de Funcionamento",
      details: ["Seg - Sáb: 8h às 18h", "Dom: Fechado"],
      description: "Estamos prontos para te atender"
    }
  ];

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-dark-900 flex items-center justify-center">
        <div className="bg-white dark:bg-dark-800 rounded-lg shadow-lg p-8 max-w-md w-full mx-4 text-center">
          <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            Mensagem Enviada!
          </h2>
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            Obrigado pelo seu contato. Nossa equipe entrará em contato em breve.
          </p>
          <button
            onClick={() => setIsSubmitted(false)}
            className="btn btn-primary"
          >
            Enviar Nova Mensagem
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{backgroundColor: 'rgb(15 23 42 / var(--tw-bg-opacity, 1))'}}>
      {/* Integrated Hero and Contact Section */}
      <div className="py-20" style={{backgroundColor: 'rgb(15 23 42 / var(--tw-bg-opacity, 1))'}}>
        <div className="container mx-auto px-4">
          {/* Hero Content - Centralized */}
          <div className="text-center mb-20">
            <div className="max-w-4xl mx-auto">
              <div className="space-y-8">
                <div className="space-y-6">
                  <span className="text-sm font-semibold text-blue-300 uppercase tracking-wider flex items-center justify-center gap-2">
                    <Car className="h-4 w-4" />
                    AVENIDA VEÍCULOS
                  </span>
                  
                  <h1 className="text-4xl md:text-5xl lg:text-6xl font-normal text-white leading-tight">
                    Encontre seu{' '}
                    <span className="font-black text-blue-300">Veículo</span>
                    {' '}dos{' '}
                    <span className="font-black text-primary-500">Sonhos</span>.
                  </h1>
                  
                  <p className="text-lg md:text-xl text-blue-100 leading-relaxed max-w-3xl mx-auto">
                    Melhores veículos seminovos e usados com qualidade garantida. 
                    Financiamento facilitado e as melhores condições do mercado.
                  </p>
                </div>

                {/* CTA Buttons - Centered */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-all duration-200 hover:scale-105 hover:shadow-lg relative overflow-hidden group"
                  >
                    <MessageCircle className="mr-2 h-5 w-5" />
                    <span className="relative z-10">Falar no WhatsApp</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-blue-500 to-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </a>
                  
                  <a
                    href="/inventory"
                    className="inline-flex items-center justify-center px-8 py-4 border-2 border-blue-400 text-blue-300 hover:bg-blue-400 hover:text-white font-semibold rounded-lg transition-all duration-200 group"
                  >
                    Ver Estoque
                    <ArrowUpRight className="ml-2 h-4 w-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-200" />
                  </a>
                </div>

                {/* Logos Carousel - Centered */}
                <div className="pt-8">
                  <LogosCarousel />
                </div>
              </div>
            </div>
          </div>
          
      {/* Professional Features Section */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-12 text-white mb-20">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">Por que escolher a Avenida Veículos?</h2>
              <p className="text-xl text-blue-100 max-w-3xl mx-auto">
                Oferecemos os melhores serviços e condições para sua satisfação
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center group">
                <div className="bg-white/20 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-white/30 transition-colors">
                  <Car className="h-10 w-10 text-white" />
                </div>
                <h3 className="text-xl font-bold mb-3">Qualidade Garantida</h3>
                <p className="text-blue-100 leading-relaxed">
                  Todos os veículos passam por inspeção técnica completa e rigorosa avaliação de qualidade
                </p>
              </div>
              
              <div className="text-center group">
                <div className="bg-white/20 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-white/30 transition-colors">
                  <Star className="h-10 w-10 text-white" />
                </div>
                <h3 className="text-xl font-bold mb-3">Melhores Condições</h3>
                <p className="text-blue-100 leading-relaxed">
                  Financiamento facilitado com as melhores taxas do mercado e condições especiais
                </p>
              </div>
              
              <div className="text-center group">
                <div className="bg-white/20 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-white/30 transition-colors">
                  <MessageCircle className="h-10 w-10 text-white" />
                </div>
                <h3 className="text-xl font-bold mb-3">Atendimento Premium</h3>
                <p className="text-blue-100 leading-relaxed">
                  Equipe especializada disponível para oferecer o melhor atendimento personalizado
                </p>
              </div>
            </div>
          </div>

          {/* Contact Section - Centralized */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Entre em <span className="text-blue-300">Contato</span>
            </h2>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
              Estamos aqui para ajudar você a encontrar o veículo ideal. 
              Nossa equipe especializada está pronta para atendê-lo com excelência.
            </p>
          </div>

          {/* Main Contact Grid - Centered */}
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-20">
              {/* Contact Information Card */}
              <div className="bg-blue-800 rounded-2xl shadow-xl p-8">
                <h2 className="text-2xl font-bold text-white mb-8 text-center">
                  Informações de Contato
                </h2>
                
                <div className="space-y-6">
                  {contactInfo.map((info, index) => (
                    <div key={index} className="flex items-start space-x-4 p-4 rounded-xl hover:bg-blue-700 transition-colors">
                      <div className="flex-shrink-0">
                        <div className="w-14 h-14 bg-blue-600 text-white rounded-xl flex items-center justify-center">
                          {info.icon}
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-white mb-2">
                          {info.title}
                        </h3>
                        <div className="space-y-1 mb-2">
                          {info.details.map((detail, detailIndex) => {
                            const content = (
                              <span className="text-blue-100 font-medium">
                                {detail}
                              </span>
                            );

                            return info.link ? (
                              <a
                                key={detailIndex}
                                href={info.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-100 font-medium hover:text-white transition-colors"
                              >
                                {content}
                              </a>
                            ) : (
                              <p key={detailIndex} className="text-blue-100 font-medium">
                                {detail}
                              </p>
                            );
                          })}
                        </div>
                        <p className="text-sm text-blue-200">
                          {info.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Map Section */}
              <div className="bg-blue-800 rounded-2xl shadow-xl overflow-hidden">
                <div className="p-6 border-b border-blue-700">
                  <h3 className="text-xl font-semibold text-white mb-2 text-center">
                    Nossa Localização
                  </h3>
                  <p className="text-blue-200 text-center">
                    Venha nos visitar em nossa loja física
                  </p>
                </div>
                <div className="h-96">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3461.41358482643!2d-51.1466875!3d-29.8234816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95196f48a646b1f5%3A0x114f02ede7227a2f!2sAvenida%20Ve%C3%ADculos!5e0!3m2!1spt-BR!2sbr!4v1758500996751!5m2!1spt-BR!2sbr" 
                    width="100%" 
                    height="100%" 
                    style={{border: 0}} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Localização da Avenida Veículos"
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Professional FAQ Section */}
      <div className="bg-gray-50 dark:bg-dark-900 py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
              Perguntas Frequentes
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Tire suas dúvidas sobre nossos serviços e processos
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            <div className="bg-white dark:bg-dark-800 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 dark:border-dark-700">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Vocês oferecem financiamento?
              </h3>
              <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                Sim! Trabalhamos com as principais financeiras do mercado e oferecemos 
                condições especiais exclusivas para nossos clientes, com taxas competitivas.
              </p>
            </div>
            
            <div className="bg-white dark:bg-dark-800 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 dark:border-dark-700">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Os veículos têm garantia?
              </h3>
              <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                Todos os nossos veículos passam por uma rigorosa inspeção técnica e 
                oferecemos garantia estendida para sua tranquilidade.
              </p>
            </div>
            
            <div className="bg-white dark:bg-dark-800 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 dark:border-dark-700">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Posso fazer um test drive?
              </h3>
              <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                Claro! Agendamos test drives para todos os veículos disponíveis. 
                Entre em contato conosco para agendar sua experiência.
              </p>
            </div>
            
            <div className="bg-white dark:bg-dark-800 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 dark:border-dark-700">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Vocês aceitam veículos como parte do pagamento?
              </h3>
              <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                Sim! Avaliamos seu veículo de forma justa e oferecemos o melhor preço 
                para troca ou consignação, facilitando sua compra.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
